import React from "react";
import { Check } from "lucide-react";
import { FAStatusBadge, WOStatusBadge } from "./StatusBadge";

// StatusBar — pipeline tahapan sebuah record, ala status bar di form Odoo.
// Tahap 5 kematangan ERP, 2 September 2026. Diukur sebelum dibuat: 2 dari 53
// halaman punya penunjuk tahapan; FA dan WO — dua record yang paling sering
// dibuka — nol punya.
//
// Yang ditampilkan adalah ALUR UTAMA: urutan yang dilalui record normal dari
// lahir sampai selesai. Status di luar alur (dibatalkan, FOC, exception)
// bukan "langkah ke-n" — ia keadaan samping, dan memaksanya masuk ke garis
// membuat garisnya berbohong. Untuk itu badge yang sudah ada dipakai apa
// adanya di tempat garis.
//
// Kosakata statusnya TIDAK diduplikasi — kunci diambil persis dari
// FA_ORDER_STATUS / WO_STATUS_TONE; yang ditulis di sini cuma label RINGKAS
// (label panjang badge nol muat sembilan kali berjajar) dan URUTANNYA.

export const FA_ALUR = [
  ["DRAFT_FA_CREATED", "Draft"],
  ["FA_WAITING_CUSTOMER_APPROVAL", "Persetujuan Customer"],
  ["FA_APPROVED_WAITING_DP", "Menunggu DP"],
  ["DP_WAITING_CONFIRMATION", "Konfirmasi DP"],
  ["DP_CONFIRMED_READY_FOR_WO", "Siap WO"],
  ["IN_PRODUCTION", "Produksi"],
  ["WAITING_PELUNASAN", "Menunggu Pelunasan"],
  ["PELUNASAN_WAITING_CONFIRMATION", "Konfirmasi Pelunasan"],
  ["LUNAS", "Lunas"],
  // ⛔ DITAMBAHKAN 9 September 2026 (ANTREAN E / Celah 1). Sebelumnya alur
  //    berakhir di "Lunas" — sistem tahu customer sudah BAYAR dan nol pernah
  //    tahu customer sudah TERIMA.
  //
  // ⚠ WAJIB SELARAS dengan `services/fa_status.ALUR`; dijaga
  //    `test_alur_utama_selaras_dengan_StatusBar`. Daftar ini SALINAN
  //    urutannya, dan salinan yang berselisih membuat StatusBar berhenti
  //    di tengah alur tanpa satu pun galat.
  ["SIAP_DISERAHKAN", "Siap Diserahkan"],
  ["DISERAHKAN", "Diserahkan"],
];

export const WO_ALUR = [
  ["DRAFT", "Draft"],
  ["PENDING_KEPALA_CABANG", "Persetujuan Kacab"],
  ["LOCKED", "Terkunci"],
  ["IN_PROGRESS", "Produksi"],
  ["COMPLETED", "Selesai"],
];

export function StatusBar({ alur, value, samping, testId = "status-bar" }) {
  const idx = alur.findIndex(([k]) => k === value);
  if (idx < 0) {
    // Keadaan samping: bukan langkah di garis. Badge-nya yang bicara.
    return (
      <div className="flex items-center gap-2 text-xs text-muted-foreground" data-testid={testId} data-samping="1">
        <span>Di luar alur utama:</span>
        {samping}
      </div>
    );
  }
  return (
    <ol className="flex flex-wrap items-center gap-y-1" data-testid={testId} aria-label="Tahapan">
      {alur.map(([k, label], i) => {
        const keadaan = i < idx ? "selesai" : i === idx ? "sekarang" : "nanti";
        const kelas =
          keadaan === "selesai" ? "bg-primary/10 text-primary border-primary/30" :
          keadaan === "sekarang" ? "bg-primary text-primary-foreground border-primary font-semibold" :
          "bg-muted text-muted-foreground border-border";
        return (
          <li key={k} className="flex items-center" data-testid={`${testId}-${k}`} data-keadaan={keadaan}>
            <span className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs whitespace-nowrap ${kelas}`}
                  aria-current={keadaan === "sekarang" ? "step" : undefined}>
              {keadaan === "selesai" && <Check size={11} />}
              {label}
            </span>
            {i < alur.length - 1 && (
              <span className={`w-3 h-px mx-0.5 ${i < idx ? "bg-primary/40" : "bg-border"}`} aria-hidden="true" />
            )}
          </li>
        );
      })}
    </ol>
  );
}

export function FAStatusBar({ value }) {
  return <StatusBar alur={FA_ALUR} value={value} samping={<FAStatusBadge value={value} />} testId="fa-status-bar" />;
}

export function WOStatusBar({ value }) {
  return <StatusBar alur={WO_ALUR} value={value} samping={<WOStatusBadge value={value} />} testId="wo-status-bar" />;
}
